import { styles } from "./Item.style";

export interface IItemProps {
  image: { url: string; title?: string; description?: string; width?: number; height?: number };
  label: string;
  text?: string;
  alt?: string;
  isImageSize?: boolean;
}

export function Item({ image, label, text, isImageSize }: IItemProps) {
  return (
    <div className={styles.divPoint()}>
      <img
        src={image.url}
        alt={image.title ?? ""}
        className={isImageSize ? styles.image() : styles.icon()}
        fetchPriority="low"
        loading="lazy"
        decoding="async"
      />
      <div className={styles.title()}>{label}</div>
      <p className={styles.text()}>{text}</p>
    </div>
  );
}
